<template>
  <div class="parent">
    <OnboardingLoading
      v-if="isLoading"
      loadingText="Verificando compra..."
      onSucessGoTo="onboarding-next-steps"
      :hideErrorLoading="true"
      onErrorGoTo="onboarding-error"
    />
    <div class="dualside-container" v-else>
      <div id="onboarding-insurance" class="insurance-page">
        <div class="insurance-container">
          <StepInfoHeader style="padding-top: 0" showHeaderHelperIcon />
          <div class="step-description">
            <h1 class="title">Contrato de financiamento da compra</h1>
          </div>
          <div class="insurance-block">
            <InsuranceOptions
              v-model="insurance"
              @change="setSkeleton"
              :options="insuranceOptions"
            />
          </div>
          <div v-if="!isMobile" class="payment-block">
            <ul class="payment-options">
              <li v-if="calculatedOptions.downPaymentValue !== 0"
              class="option" :class="{ skeleton: skeleton }">
                <span class="option-title" :style="{ visibility: !skeleton }">{{
                  downPaymentText
                }}</span>
                <span v-if="!skeleton" class="option-value">{{
                  formattedDownPayment
                }}</span>
              </li>
              <li class="option" :class="{ skeleton: skeleton }">
                <span class="option-title" :style="{ visibility: !skeleton }">
                  Parcelas {{ insurance ? '+ Seguro' : null }}
                </span>
                <span v-if="!skeleton" class="option-value">{{
                  `${calculatedOptions.numberOfInstallments}x de
                  ${installmentValue}`
                }}</span>
              </li>
              <li style="display: flex; flex-direction: column; width: 100%">
                <div class="option" :class="{ skeleton: skeleton }">
                  <span class="option-title">Valor total</span>
                  <span v-if="!skeleton" class="option-value">{{
                    formattedTotalAmount
                  }}</span>
                </div>
              </li>
            </ul>
            <Button class="continue-button" color="primary" @click="actionEvent">
              {{ "Continuar" }}
            </Button>
          </div>
        </div>
        <div v-if="isMobile" class="payment-block">
            <ul class="payment-options">
              <li v-if="calculatedOptions.downPaymentValue !== 0"
              class="option" :class="{ skeleton: skeleton }">
                <span class="option-title" :style="{ visibility: !skeleton }">{{
                  downPaymentText
                }}</span>
                <span v-if="!skeleton" class="option-value">{{
                  formattedDownPayment
                }}</span>
              </li>
              <li class="option" :class="{ skeleton: skeleton }">
                <span class="option-title" :style="{ visibility: !skeleton }">
                  Parcelas {{ insurance ? '+ Seguro' : null }}
                </span>
                <span v-if="!skeleton" class="option-value">{{
                  `${calculatedOptions.numberOfInstallments}x de
                  ${installmentValue}`
                }}</span>
              </li>
              <li style="display: flex; flex-direction: column; width: 100%">
                <div class="option" :class="{ skeleton: skeleton }">
                  <span class="option-title">Valor total</span>
                  <span v-if="!skeleton" class="option-value">{{
                    formattedTotalAmount
                  }}</span>
                </div>
              </li>
            </ul>
            <Button class="continue-button" color="primary" @click="actionEvent">
              {{ "Continuar" }}
            </Button>
          </div>
      </div>
      <div v-if="!isMobile" class="details-parent">
        <div v-if="!isMobile" class="details-side">
          <div style="display: flex; flex-direction: column; gap: 4px; width: 100%">
            <span style="font-weight: 700">Pedido {{ onboardingOverviewData.orderId }}</span>
            <span
              style="display: flex; width: 100%; line-height: 20px; font-size: 14px; color: #64748b"
              >Realizado em {{ formattedDate }}<span style="margin-left: auto">1 Item</span></span
            >
          </div>
          <div style="display: flex; flex-direction: column; gap: 12px">
            <div
              v-for="product in onboardingOverviewData.products"
              :key="product.id"
              style="display: flex; flex-direction: row; gap: 12px; width: 100%"
            >
              <img :src="product.image" style="width: 48px; height: 48px" />
              <div style="max-width: 370px; width: 100%">
                <span
                  style="
                    font-size: 14px;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 20px;
                  "
                >
                  {{ product.name }}
                </span>
                <span
                  style="
                    display: flex;
                    width: 100%;
                    line-height: 16px;
                    font-size: 12px;
                    color: #64748b;
                  "
                  >Qtd: {{ String(product.amount).padStart("2", "0")
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              font-size: 14px;
              font-style: normal;
              line-height: 20px;
            "
          >
            <span style="font-weight: 600; padding-bottom: 8px">Endereço de entrega</span>
            <span style="text-transform: capitalize">{{ fullName }}</span>
            <span>{{ onboardingOverviewData.address || "" }}</span>
            <span>{{
              onboardingOverviewData.city || "" + " - " + onboardingOverviewData.state
            }}</span>
            <span>{{ onboardingOverviewData.zipCode || "" }}</span>
            <span>{{ "Tel: " + onboardingOverviewData.phone || "" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StringMixin from '@/mixins/string';
import InsuranceOptions from '@/feature/onboarding/components/InsuranceOptions.vue';
import Button from '@/components/ui/AppButton.vue';
import moment from '@/lib/moment-ptbr';
import StepInfoHeader from '../components/StepInfoHeader.vue';
import OnboardingLoading from './OnboardingLoading.vue';

export default {
  name: 'onboarding-insurance',
  data: () => ({
    insurance: true,
    skeleton: false,
    isLoading: true,
  }),
  mixins: [StringMixin],
  components: { Button, StepInfoHeader, InsuranceOptions, OnboardingLoading },
  async mounted() {
    this.isLoading = true;
    await this.fetchInsuranceOptions();
    const yearsOld = moment().diff(this.getBirthDate, 'years');

    if (yearsOld >= 70) {
      this.isLoading = true;
      await this.sendInsuranceConfirmation(false);
      await this.handleNextStep();
    } else {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('onboarding', ['insuranceOptions', 'onboardingOverviewData', 'getBirthDate']),
    calculatedOptions() {
      return this.insurance
        ? this.insuranceOptions.insuranceOption
        : this.insuranceOptions.originalOption;
    },
    isMobile() {
      return window.innerWidth < 1023;
    },
    fullName() {
      if (!this.onboardingOverviewData.name) return;
      const name = this.onboardingOverviewData.name.split(' ');
      // eslint-disable-next-line consistent-return
      return name[0] + name[name.length - 1];
    },
    formattedDate() {
      const date = new Date(this.onboardingOverviewData.createdAt);
      // eslint-disable-next-line consistent-return
      return date.toLocaleDateString('pt-BR');
    },
    downPaymentText() {
      return this.calculatedOptions?.downPaymentPercentage
        ? `Entrada
                  (${this.calculatedOptions.downPaymentPercentage}%)`
        : 'Entrada';
    },
    formattedDownPayment() {
      return this.calculatedOptions?.downPaymentValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    formattedTotalAmount() {
      return this.calculatedOptions.totalAmount.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    installmentValue() {
      return this.calculatedOptions?.paymentInstallments.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
  },
  methods: {
    ...mapActions('onboarding', [
      'setLoading',
      'fetchInsuranceOptions',
      'sendInsuranceConfirmation',
      'getOnboarding',
    ]),
    async actionEvent() {
      this.isLoading = true;
      try {
        await this.sendInsuranceConfirmation(this.insurance);
        await this.handleNextStep();
      } catch {
        this.$router.replace({
          name: 'onboarding-error',
          query: this.$route.query,
        });
      }
    },
    async handleNextStep() {
      const {
        transactionId,
        onboardingToken,
        facetecErrorCount,
      } = this.$route.query;
      await this.getOnboarding({ transactionId, onboardingToken, facetecErrorCount });

      this.$router.replace({
        name: 'onboarding-signature-contract-view',
        query: this.$route.query,
      }).finally(() => {
        this.isLoading = false;
      });
    },
    setSkeleton() {
      this.skeleton = true;
      setTimeout(() => {
        this.skeleton = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.parent {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;

  @media (min-width: $md) {
    overflow: hidden;
  }
}

.skeleton {
  background-color: #e5e7eb;
  animation: pulse 0.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.dualside-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 1000px;

  @media (min-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    flex-direction: row;
    justify-content: center;
  }

  .details-parent {
    display: none;

    @media (min-width: 1024px) {
      display: flex;
      flex-grow: 1;
      width: 100%;
      min-height: 100%;
    }

    .details-side {
      display: flex;
      position: relative;
      padding: 24px 36px;
      flex-direction: column;
      gap: 24px;
      max-width: 370px;
      width: 100%;
      min-height: 100%;
      background-color: #f3f4f6;

      &:after {
        content: "";
        display: none;

        @media (min-width: 1024px) {
          display: block;
          position: absolute;
          background: #f3f4f6;
          top: 0;
          left: 100%;
          width: 100vw;
          height: 100%;
        }
      }
    }

    @media (min-width: 1024px) {
      display: block;
    }
  }

  .insurance-page {
    display: flex;
    position: relative;
    padding: 24px;
    z-index: 10;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;

    @media (min-width: 1024px) {
      position: sticky;
      padding: 24px 36px;
      flex-direction: row;
      width: 100%;
      max-width: 558px;
    }

    .payment-block {
        display: flex;
        margin-top: auto;
        gap: 24px;
        flex-direction: column;

        @media (min-width: $md) {
          position: static;
          width: 100%;
        }

        @media (min-width: 1024px) {
          margin-top: 0;
        }

        .payment-options {
          display: flex;
          padding: 12px;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          margin-top: auto;
          align-self: stretch;
          border-radius: 6px;
          background: #f1f5f9;

          .option {
            display: flex;
            flex-direction: row;
            width: 100%;

            > .option-title {
              flex-grow: 1;
            }

            > .option-value {
              color: #0f172a;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 24px;
            }
          }
        }

        .continue-button {
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          width: 100%;
          height: 48px;
          padding: 12px 24px;
          font-weight: 600;

          @media (min-width: 1024px) {
            width: 125px;
            margin-bottom: 0;
          }
        }
      }

    .insurance-container {
      display: flex;
      position: relative;
      flex-direction: column;
      gap: 24px;
      height: 100%;
      color: #0f172a;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      .step-description {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;

        > .title {
          color: var(#0f172a);
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 32px;
        }

        > .description {
          color: var(#0f172a);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
      }

      .insurance-block {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .container-title {
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
